import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function formatServiceUnavailabilityReason(serviceUnavailabilityReasonEnum) {
    serviceUnavailabilityReasonEnum = serviceUnavailabilityReasonEnum.split('_').join(' ');
    return serviceUnavailabilityReasonEnum;
}

export default function ServiceUnavailable({ rideBookingLogicData }) {
    const serviceUnavailabilityReasonFormatted = formatServiceUnavailabilityReason(
        rideBookingLogicData.serviceStatus.serviceUnavailabilityReason
    );

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 6,
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    color: '#000000',
                    backgroundColor: 'rgb(249,164,9)',
                    borderRadius: 3,
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                    paddingTop: 1.0,
                    paddingBottom: 1.0,
                    fontSize: 30,
                    fontWeight: '900',
                    marginBottom: 2,
                }}
            >
                {serviceUnavailabilityReasonFormatted}
            </Typography>

            {/* <Typography
        variant="h3"
        sx={{
          color: "#ffffff",
          borderRadius: 3,
          paddingLeft: 1.5,
          paddingRight: 1.5,
          paddingTop: 1.0,
          paddingBottom: 1.0,
          fontSize: 14,
        }}
      >
        Zipzy Is Currently Unavailable
      </Typography> */}

            <Typography
                variant="h3"
                sx={{
                    ml: 1,
                    fontSize: 22,
                    fontWeight: '600',
                    color: 'white',
                }}
            >
                {rideBookingLogicData.serviceStatus.serviceRestartingWhenStrIst}
            </Typography>
        </Box>
    );
}
